export default "__VITE_PUBLIC_ASSET__ca35fd4b__"